let Hooks = {}

Hooks.SelectList = {
    mounted() {
        let component = this
        let input = this.el.getElementsByTagName('input')[0];

        if (input.dataset.onchange) {
            input.addEventListener("input", (event) => {
                this.pushEvent(input.dataset.onchange, {id: component.el.id, q: input.value})
            });
        } else {
            input.addEventListener("input", (event) => {
                component.el.querySelectorAll('.list-item').forEach((item) => {
                    let name = item.querySelectorAll(".title")[0].innerHTML
                    name = name.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
                    if (name.includes(input.value.toLowerCase())) {
                        item.classList.remove("hide")
                    } else {
                        item.classList.add("hide")
                    }
                });
            });
        }

        document.addEventListener('click', (event) => {
            document.querySelectorAll('.select-list').forEach((selectList) => {
                let list = component.el.querySelector(".list")
                if (event.composedPath().includes(component.el) && !event.composedPath().includes(list)) {
                    component.el.classList.add("expanded")
                    component.expanded = true
                    this.el.getElementsByTagName('input')[0].focus();
                } else {
                    component.el.classList.remove("expanded")
                    this.expanded = false
                }
            })
        })
    },

    updated() {
        if (this.expanded) {
            this.el.classList.add("expanded")
        }
    }
}

export {Hooks}